// extracted by mini-css-extract-plugin
export default {"foldersSkeleton":"foldersSkeleton_foldersSkeleton__yvEQD","folder":"foldersSkeleton_folder__2t+bj"};